import { createContext, type RefObject, useContext } from "react";

import type { Point, Size } from "../types.ts";

export type BoundRestriction = {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
};

type DimensionsContext = {
  width: number;
  height: number;
  padding: number;
  viewportSize?: Size;
  viewportRef: RefObject<HTMLElement | null>;
  setViewportRef: (node: HTMLElement | null) => void;
  usableWidth: number;
  usableHeight: number;
  positionOrigin: Point;
  moduleMapBounds: BoundRestriction;
};

export const DimensionsContext = createContext<DimensionsContext | undefined>(undefined);
DimensionsContext.displayName = "DimensionsContext";

export const useDimensions = () => {
  const dimensionsContext = useContext(DimensionsContext);
  if (!dimensionsContext) {
    throw new Error(`Expected DimensionsContext in component tree.`);
  }
  return dimensionsContext;
};
